import {useStores} from "../../Hooks";
import './fastTrack.scss';
import frontlineLogoBlueNoShade from '../../assets/img/frontline-logo-blue-no-shade.png';
import vLogo from '../../assets/img/v-logo.png';
import React, {useEffect, useState} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {GeneralRequester} from "../../MobxStores/RequestApi/GeneralRequester";
import {observer} from "mobx-react";
import {CircularProgress} from "@mui/material";
import {WarningIcon} from "../../assets/svg-icons/WarningIcon";
import {hotjar} from "react-hotjar";
import Settings from "../../settings.json";

const statuses = {
    PENDING: 'pending',
    ERROR: 'error',
    VERIFIED: 'verified'
}

const FastTrackVerify = observer(() => {
    const {generalStore} = useStores();
    const [verifyStatus, setVerifyStatus] = useState(statuses.PENDING);

    useEffect(() => {
        hotjar.initialize(Settings.hotjarId, 6);
    }, []);

    // eslint-disable-next-line
    useEffect(async () => {
        try {
            GeneralRequester.sendAnalyticsEvent('Fast Track - clicked verify', 'fast-track').then();
            const urlParams = new URLSearchParams(window.location.search);
            const code = urlParams.get('code');
            await GeneralRequester.verifyFastTrack(code);
            setVerifyStatus(statuses.VERIFIED);
            GeneralRequester.sendAnalyticsEvent('Fast Track - verified', 'fast-track').then();
        } catch (e) {
            setVerifyStatus(statuses.ERROR);
            GeneralRequester.sendAnalyticsEvent('Fast Track - verification failed', 'fast-track').then();
        }
        // eslint-disable-next-line
    }, []);


    // noinspection XmlDeprecatedElement
    return (
        <div className='fast-track-container'>
            <div className='fast-track-background-container'>

                <div className='fast-track-step'>

                    <div className='fast-track-done-logo-container'>
                        <img src={frontlineLogoBlueNoShade} alt=''/>
                    </div>

                    <ConditionalComponent if={verifyStatus === statuses.PENDING}>
                        <div className='v-logo-container'>
                            <CircularProgress color='primary' variant='indeterminate'/>
                        </div>
                        <div className='fast-track-done-title'>
                            {generalStore.translate('verifyingYourAccount')}...
                        </div>
                    </ConditionalComponent>
                    <ConditionalComponent if={verifyStatus === statuses.ERROR}>
                        <div className='v-logo-container'>
                            <WarningIcon htmlColor='#FF1F1F' fontSize='large'/>
                        </div>
                        <div className='fast-track-done-title'>
                            {generalStore.translate('couldNotVerifyYourAccount') + '!'}
                        </div>
                        <div className='fast-track-contact'>
                            {generalStore.translate('pleaseContactOur')}&nbsp;
                            <a href='https://helpdesk.frontline.io/hc/en-us/requests/new?ticket_form_id=10235994207505'
                               rel="noreferrer" target='_blank'>
                                {generalStore.translate('supportTeam', true)}
                            </a>
                        </div>
                    </ConditionalComponent>
                    <ConditionalComponent if={verifyStatus === statuses.VERIFIED}>
                        <div className='fast-track-done-message-container'>
                            <div className='v-logo-container'>
                                <img src={vLogo} alt=''/>
                            </div>
                            <div className='fast-track-done-title'>
                                {generalStore.translate('emailVerified')}
                            </div>
                            <div className='fast-track-verified-description'>
                                {generalStore.translate('inTheNextBusinessDayYouWillReceiveYourDigitalTwin') + ' 3D ' + generalStore.translate('model', true) + '.'}<br/>
                                {generalStore.translate('meanwhile') + ', ' + generalStore.translate('hereAreDetailedInstructionsOnHowToDownloadOur', true) + ' PC ' + generalStore.translate('appAndToStartEditingYourPartsCatalogOnceYourDigitalTwinIsAvailable', true) + '.'}
                            </div>
                            <div className='fast-track-video-container'>
                                <div className='fast-track-video'>

                                    <iframe width="326" height="184"
                                            src="https://player.vimeo.com/video/771923847?h=553945f697"
                                            title="Vimeo video player" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen></iframe>
                                    <div>
                                        <a
                                            href='https://frontlinehelpdesk.zohodesk.com/portal/en/kb/articles/creating-your-digital-twin-a-guide-to-using-frontline-io-fast-track-feature'
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            From CAD file to interactive parts catalog
                                        </a>
                                    </div>
                                </div>
                                <div className='fast-track-video'>
                                    <iframe width="326" height="184"
                                            src="https://player.vimeo.com/video/771922680?h=883e154c2c"
                                            title="Vimeo video player" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen></iframe>
                                    <div>
                                        <a
                                            href='https://helpdesk.frontline.io/hc/en-us/articles/7767697791377'
                                            target='_blank'
                                            rel="noreferrer"
                                        >
                                            How to edit your parts catalog
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <div className='fast-track-contact'>
                                {generalStore.translate('ifYouHaveAnyQuestionsConcerningFastTrack') + ', ' + generalStore.translate('pleaseContactOur', true)}&nbsp;
                                <a href='https://helpdesk.frontline.io/hc/en-us/requests/new?ticket_form_id=10235994207505'
                                   rel="noreferrer" target='_blank'>
                                    {generalStore.translate('supportTeam', true)}
                                </a>
                            </div>

                            <div className='fast-track-contact'>
                                {generalStore.translate('exploreOtherCapabilities') + ' frontline.io ' + generalStore.translate('hasToOfferInOur', true)}&nbsp;
                                <a href='https://frontline.io/showroom/' target='_blank'
                                   rel='noreferrer'>{generalStore.translate('Showroom')}</a>.
                            </div>
                        </div>
                    </ConditionalComponent>
                </div>

            </div>
        </div>
    )
});
export default FastTrackVerify;
